module.exports = __webpack_public_path__ + "static/media/shell.cf1d6e9a.png";